import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TeContainer, TeContainerSlim, TeText } from '@topcon/tuicl-react';

import { ServiceAgreementTermsEnum } from '../../../api/generated/pm';
import SelectableAgreementTypeCard from '../SelectableAgreementTypeCard';
import ServiceAgreementAcknowledgements from '../ServiceAgreementAcknowledgements';
import { AgreementType } from '../../../types/customer-modal.types';

interface SelectAgreementStepProps {
  agreementType?: ServiceAgreementTermsEnum;
  onSelectAgreement: (agreementType: ServiceAgreementTermsEnum) => void;
  onAcknowledgedChange: (acknowledged: boolean) => void;
}

function SelectAgreementStep({
  onSelectAgreement,
  agreementType,
  onAcknowledgedChange,
}: SelectAgreementStepProps) {
  const { t } = useTranslation();
  const [selectedAgreementType, setSelectedAgreementType] = useState<ServiceAgreementTermsEnum>(
    agreementType ?? ServiceAgreementTermsEnum.FULL_SERVICE
  );

  const handleSelectAgreement = (agreementType: ServiceAgreementTermsEnum) => {
    setSelectedAgreementType(agreementType);
    onSelectAgreement(agreementType);
  };

  return (
    <TeContainer
      column
      grow
      backgroundColor="background.secondary"
      gap="m"
      overflow="auto"
      justifyContent="center"
      borderRadius="l"
    >
      <TeContainerSlim fill grow column justifyContent="center" gap="xs">
        <TeText weight={700} size={16}>
          {t('serviceAgreementType')}
        </TeText>
        <TeText weight={400} size={12} color="text.secondary">
          {t('serviceAgreementTypeDescription')}
        </TeText>
      </TeContainerSlim>
      <TeContainerSlim fill grow alignItems="center" gap="xs">
        <SelectableAgreementTypeCard
          title={t('serviceAgreement.full_service')}
          agreementType={AgreementType.FullService}
          isActive={selectedAgreementType === ServiceAgreementTermsEnum.FULL_SERVICE}
          onClick={() => handleSelectAgreement(ServiceAgreementTermsEnum.FULL_SERVICE)}
        />
        <SelectableAgreementTypeCard
          title={t('serviceAgreement.limited_service')}
          agreementType={AgreementType.LimitedService}
          isActive={selectedAgreementType === ServiceAgreementTermsEnum.PARTIAL_SERVICE}
          onClick={() => handleSelectAgreement(ServiceAgreementTermsEnum.PARTIAL_SERVICE)}
        />
      </TeContainerSlim>
      <ServiceAgreementAcknowledgements
        side="dealer"
        tier={selectedAgreementType}
        onAcknowledged={onAcknowledgedChange}
        variant="modal"
      />
    </TeContainer>
  );
}

export default SelectAgreementStep;
